import { toTitleCase } from "@/lib/utils/characters"
import React from "react"

interface ErrorCardProps {
  message: string
  className?: string
}

export function ErrorCard({ message, className }: ErrorCardProps) {
  return (
    <div
      className={`rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-destructive ${className || ""}`}
      role="alert"
    >
      {toTitleCase(message)}
    </div>
  )
}
